import { DocumentNode, gql } from '@apollo/client';
import { HStack, Text } from '@chakra-ui/react';
import * as React from 'react';

import { OrganizationProfileImage } from '@/components/OrganizationProfileImage';

import { SponsorDetail_SimpleEventFragment } from './graphql-types/SponsorDetail_SimpleEventFragment';

export const SponsorDetail: React.FC<{
  simpleEvent: SponsorDetail_SimpleEventFragment;
}> & {
  simpleEventFragment: DocumentNode;
} = ({ simpleEvent }) => {
  if (!simpleEvent.hostOrganization) {
    return null;
  }

  return (
    <HStack alignItems="center">
      <OrganizationProfileImage
        organization={simpleEvent.hostOrganization}
        h="12"
        w="12"
        p="1"
      />
      <Text textStyle="body">
        <Text as="span" fontWeight="semibold">
          {simpleEvent.hostOrganization.displayName}
        </Text>{' '}
        is hosting an event
      </Text>
    </HStack>
  );
};

SponsorDetail.simpleEventFragment = gql`
  fragment SponsorDetail_SimpleEventFragment on SimpleEventV2 {
    _id
    visibility {
      groupIds
      userIds
      type
    }
    hostOrganization {
      _id
      displayName
      ...OrganizationProfileImage_OrganizationFragment
    }
  }
  ${OrganizationProfileImage.organizationFragment}
`;
